import { Component, inject } from '@angular/core';
import { IdentityService } from '../identity.service';

@Component({
  selector: 'lib-invalid-domain',
  templateUrl: './invalid-domain.component.html',
  styleUrls: ['./invalid-domain.component.scss'],
     
})
export class InvalidDomainComponent {
  private identityService = inject(IdentityService);

  
 

  

  logout() {
    this.identityService.logout(false);
  }
}
